module.exports = __webpack_public_path__ + "static/img/6.8af859e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/6.png
// module id = dYqO
// module chunks = 0